/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAllPersonas } from 'features/forms/personas/reducer/PersonaActions';
import React from 'react';
import OwnerDropdown from 'shared/dropdowns/cx-dropdown/OwnerDropdown';
import PriorityDropdown from 'shared/dropdowns/cx-dropdown/PriorityDropdown';
import StatusDropdown from 'shared/dropdowns/cx-dropdown/StatusDropdown';
import DepartmentDropdown from 'shared/dropdowns/library-dropdown/DepartmentDropdown';
import GroupDropdown from 'shared/dropdowns/library-dropdown/group/GroupDropdown';
import SystemDropdown from 'shared/dropdowns/library-dropdown/SystemDropdown';
import TagsDropdown from 'shared/dropdowns/library-dropdown/tags/TagsDropdown';
import TouchpointDropdown from 'shared/dropdowns/library-dropdown/TouchpointDropdown';
import { InformationType } from 'utils/optionsSets/OptionSets';
import AdvancedRatings from '../advanced-ratings';
import AttachPopover from '../attach-popover';
import Date from '../date';
import PersonaRelations from '../PersonaRelation';
import Rating from '../rating';

export interface PanelColumn {
    icon: string;
    type?: number;
    Component: React.ComponentType<any>; // Accept any component
    componentProps?: any;
    disableHide?: boolean;
    attribute?: any;
}

// Example columns array with dynamic components
export const columns: PanelColumn[] = [
    {
        type: InformationType.Persona,
        icon: 'PERSONA',
        Component: PersonaRelations, // Example component, import this correctly
        componentProps: {
            reduxActions: [getAllPersonas],
            recordType: "cem_cxopportunity",
            entityType: "cem_persona",
        },
    },
    {
        type: InformationType.Status,
        icon: 'circle',
        Component: StatusDropdown,
        componentProps: {
            recordType: "cem_cxopportunity",
            entityType: "cem_status",
            attributeName: "statusId",
            single: true

        },
        disableHide: true

    },
    {
        type: InformationType.Priority,
        icon: 'arrow-up-big-small',
        Component: PriorityDropdown,
        componentProps: {
            entityType: "cem_priority",
            attributeName: "priorityId",
            single: true
        },
        disableHide: true

    },
    {
        type: InformationType.DueDate,
        icon: 'calendar',
        Component: Date,
        componentProps: {
            attributeName: "date",
            single: true
        }
    },
    {
        type: InformationType.Owner,
        icon: 'user',
        Component: OwnerDropdown,
        componentProps: {
            attributeName: "userId",
            single: true
        }
    },

    {
        type: InformationType.Rating,
        icon: 'star',
        Component: Rating,
        componentProps: {
            attributeName: "ratingValue",
            single: true
        }

    },
    {
        type: InformationType.AdvancedRating,
        icon: 'star',
        Component: AdvancedRatings,
        componentProps: {
            attributeName: "ratingValue",
            single: true
        }

    },
    {
        type: InformationType.Tags,
        icon: 'tag',
        Component: TagsDropdown,
        componentProps: {
            disabledSpinner: true,
            recordType: "cem_cxattribute",
            entityType: "cem_tag",
            attributeName: "tags",

        }
    },
    {
        type: InformationType.Group,
        icon: 'tag',
        Component: GroupDropdown,
        componentProps: {
            recordType: "cem_cxattribute",
            entityType: "cem_group",
            attributeName: "groups",

        }
    },
    {
        type: InformationType.Touchpoints,
        icon: 'circle-dot',
        Component: TouchpointDropdown,
        componentProps: {
            entityType: "cem_touchpoints",
            attributeName: "linkedTouchpoints",
        }
    },
    {
        type: InformationType.Systems,
        icon: 'SYSTEM_DUOTONE',
        Component: SystemDropdown,
        componentProps: {
            entityType: "cem_libraryvalue",
            attributeName: "linkedLibraryValue",
        }
    },
    {
        type: InformationType.Departments,
        icon: 'DEPARTMENT_DUOTONE',
        Component: DepartmentDropdown,
        componentProps: {
            entityType: "cem_libraryvalue",
            attributeName: "linkedLibraryValue",
        }
    },
    {
        type: InformationType.Attachment,
        icon: 'file',
        Component: AttachPopover,
        componentProps: {
            upsertAttachItem: () => { },
        }
    },

    // Add more columns with different components as needed
];

export const columnsOrder = columns.map(c => c.type)